<script>
    import {Link} from "svelte-routing";
    import {researchers_values} from './data.js'
</script>

<div class="col s12">
    {#each researchers_values as researcher (researcher.id)}
        {#if researcher.image!=null}
            <Link to="researchers/{researcher.id}">
                <img src="/content/people/{researcher.id}.png" width="50" alt="{researcher.name}"
                     title="{researcher.name}"/>
            </Link>
        {/if}
    {/each}
</div>